<div
  class="flex cursor-pointer items-center gap-3 rounded-lg border-2 p-2 transition-all hover:shadow-sm"
  [ngClass]="{
    'bg-primary-50 border-primary-500': isSelected(),
    'border-slate-200': !isSelected() && !isDisabled(),
    'cursor-not-allowed border-red-200 bg-red-50 opacity-60': isDisabled()
  }"
  [matTooltip]="tooltipText()"
  [matTooltipDisabled]="!isDisabled()"
  (click)="toggled.emit()"
>
  <div
    class="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded bg-slate-100"
  >
    @if (isImage() && (thumbnailUrl$() | async); as thumbnailUrl) {
      <img
        class="h-full w-full object-cover"
        [src]="thumbnailUrl"
        [alt]="name()"
      />
    } @else {
      <mat-icon class="text-slate-400">
        {{ icon() }}
      </mat-icon>
    }
  </div>

  <div class="min-w-0 flex-1">
    <p
      class="truncate text-sm font-medium"
      [ngClass]="{
        'text-primary-700': isSelected(),
        'text-slate-700': !isSelected() && !isDisabled(),
        'text-warn-400': isDisabled()
      }"
    >
      {{ name() }}
    </p>
    <p class="truncate text-xs text-slate-500">
      {{ actorName() }}
    </p>
  </div>

  <div
    class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full"
    [ngClass]="{
      'bg-primary-500': isSelected(),
      'border border-slate-300 bg-white': !isSelected() && !isDisabled(),
      'border border-red-300 bg-red-100': isDisabled()
    }"
  >
    @if (isSelected()) {
      <mat-icon class="icon-sm text-white">check</mat-icon>
    }
    @if (isDisabled()) {
      <mat-icon class="icon-sm text-warn-400">block</mat-icon>
    }
  </div>
</div>
